import { render, staticRenderFns } from "./SolidCalendarIcon.vue?vue&type=template&id=47b5d576&"
import script from "./SolidCalendarIcon.vue?vue&type=script&lang=ts&"
export * from "./SolidCalendarIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports